import { AspectRatio } from './../../api/models/media.models';
import { IUploadType, IImage, IUploadedFile, IImageUploadRequest, IImageDeleteRequest, IImageUploadResponse } from '@app/api/models/media.models';

export const cropperDialogConfig = (image: IImage, imageType: IUploadType, editable: boolean) => ({
  width: '100%',
  height: '100%',
  panelClass: 'cropper-panel',
  disableClose: true,
  data: {
    image,
    editable,
    imageType,
  },
});

export const snackBarConfig = {
  duration: 5000,
  panelClass: 'upload-inform',
};

export function buildRequest(uploadedFiles: IUploadedFile[], imageType: IUploadType, establishmentId: string): IImageUploadRequest {
  return {
    imageType,
    images: uploadedFiles.map(file => file.file),
    establishmentId,
  };
}

export function buildDeleteRquest(imageToDelete: IImageUploadResponse, establishmentId: string): IImageDeleteRequest {
  const { metadata, url } = imageToDelete;
  let mediaId = '';

  if (metadata && Object.keys(metadata).length) {
    const { name } = metadata;
    const string = name.split('/');
    mediaId = string[string.length - 1];
  }

  return {
    establishmentId,
    files: [{ mediaId, url }],
  };
}

export function getFIleExtension(sourceUrl: string): string {
  const splitedSource = sourceUrl.split('.');
  const extension = splitedSource[splitedSource.length - 1];
  return extension ? `image/${extension}` : 'image/jpg';
}

export const invalidExtensionErrorKey = 'csa.media.upload.error.extension';

export const invalidFilekey = 'csa.media.upload.error.invalid.file';

export const invalidSizeKey = 'csa.media.upload.error.invalid.size';

export const cropperPanelClass = 'cropper-panel';

export const cropperPanelEditableClass = 'cropper-panel-editable';

export function getAspectRatio(width: number, height: number): AspectRatio {
  return width > height ? AspectRatio.HORIZONTAL : AspectRatio.VERTIFICAL;
}
